import { useCallback } from 'react'
import { graphql, useMutation } from 'react-relay'

import {
  type useMatchMutation as UseMatchMutation,
  type useMatchMutation$data
} from '@/__generated__/useMatchMutation.graphql'

type CommitAsyncFn = (toUserId: string) => Promise<useMatchMutation$data>

export const useMatchMutation = (): [CommitAsyncFn, boolean] => {
  const [commit, isPending] = useMutation<UseMatchMutation>(graphql`
    mutation useMatchMutation($input: CreateMatchInput!) {
      createMatch(input: $input) {
        match {
          rowId
          ...MatchMessagesView_match
          ...MatchMessagesViewRefetchable_match
        }
        query {
          currentUser {
            ...MessagesView_user @arguments(after: null)
          }
        }
      }
    }
  `)

  const commitAsync = useCallback<CommitAsyncFn>(
    (toUserId: string) =>
      new Promise((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors[0])
            } else {
              resolve(response)
            }
          },
          variables: {
            input: {
              match: {
                toUserId
              }
            }
          }
        })
      ),
    [commit]
  )

  return [commitAsync, isPending]
}
